!function() {
  "use strict";
  customElements.get("header-menu") || customElements.define("header-menu", class extends HTMLElement {
    constructor() {
      super(), this.level1DetailsToggle = this.querySelector("details.header--level1"), 
      this.level2DetailsToggles = this.querySelectorAll("details.header--level2"), this.level1DetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this)), 
      this.level1DetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
      for (const e of this.level2DetailsToggles) e.addEventListener("toggle", this.onToggle2.bind(this));
    }
    onFocusOut() {
      setTimeout((() => {
        this.contains(document.activeElement) || this.close();
      }));
    }
    onToggle(e) {
      "open" === e.oldState && this.querySelector("details.header--level2[open]")?.removeAttribute("open");
    }
    onToggle2(e) {
      if ("open" === e.oldState) return;
      const t = this.querySelector(`details.header--level2[open]:not(#${e.target.id})`);
      t && (t.removeAttribute("open"), t.querySelector("summary.header--level2").setAttribute("aria-expanded", !1));
    }
    close() {
      this.level1DetailsToggle.removeAttribute("open"), this.level1DetailsToggle.querySelector("summary.header--level1").setAttribute("aria-expanded", !1);
    }
  });
}();